/**
 * Memories API Client for Admin Dashboard
 * Stats-only endpoint (admin aggregation)
 */

import apiClient from './client';

export interface MemoryStats {
  total_memories: number;
  users_with_memories: number;
}

export const memoriesApi = {
  async getStats(): Promise<MemoryStats> {
    const response = await apiClient.get<MemoryStats>('/memories/stats');
    return response.data;
  },
};
